import React from "react";
//Limitless imports
import { useKnowledgeLibraryContext, LoadingSpinner, KnowledgeArticleList } from "@limitless/portal";
import Grid from "@limitless/modern/layout/Grid";
import Typography from "@limitless/modern/data-display/typography/Typography";

const KnowledgeArticles = () => {
    const { libraryResults } = useKnowledgeLibraryContext();
    const { hasSearched, searching, loading } = libraryResults;

    return (
        <>
            <Typography variant="h6" sx={{ color: theme => theme.palette.grey[4], marginBottom: 1 }}>
                {hasSearched ? "Search results" : "Frequently Asked Questions"}
            </Typography>
            {loading || searching ? (
                <Grid container alignItems={"center"} justifyContent={"center"}>
                    <LoadingSpinner />
                </Grid>
            ) : (
                <KnowledgeArticleList />
            )}
        </>
    );
};

export default KnowledgeArticles;